// extracted by mini-css-extract-plugin
export default {"container":"AboutBook_container__RTa2P","detailContainer":"AboutBook_detailContainer__dtg-u","details":"AboutBook_details__9QPu-","description":"AboutBook_description__awr3B"};